import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { EntityService } from 'src/app/services/entity.service';
import { formatDate as formatDateUtil } from 'src/app/utils/dates.utils';

@Component({
  selector: 'app-catalog-suggestion-review',
  templateUrl: './catalog-suggestion-review.component.html',
  styleUrls: [ './catalog-suggestion-review.component.scss' ],
})
export class CatalogSuggestionReviewComponent {
  @Input() course: any;
  @Input() showStatusRow: any = false;

  constructor(
    public dialog: MatDialog,
    private entityService: EntityService,
  ) {}

  formatDate(date: any): string {
    const timezone = this.entityService.getLocalTimezone();
    return formatDateUtil.asDateWithTimezone(date, timezone);
  }

  formatTime(timeString: string): string {
    if (!timeString) return '';
    
    // Handle "Anytime" case
    if (timeString === 'Anytime') return 'Anytime';

    if (timeString.includes('AM') || timeString.includes('PM')) return timeString;
    
    // Parse 24-hour format (HH:MM) and convert to 12-hour format with AM/PM
    const [hours, minutes] = timeString.split(':');
    if (!hours || !minutes) return timeString;
    
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 % 12 || 12;
    const ampm = hour24 >= 12 ? 'PM' : 'AM';
    
    return `${hour12}:${minutes} ${ampm}`;
  }

  viewReason() {
    this.dialog.open(VerificationComponent, {
      data: {
        title: 'Reason for Denial',
        text: this.course?.statusComments,
        icon: 'info',
        confirmButtonTitle: 'Ok',
      },
    });

  }


}
